export default __webpack_public_path__ + "static/media/SAS0050.34I-34118_-18335_50.3fc208b7.jpg";